// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c5227a3e","845":"ce48b296"}[chunkId] + ".chunk.js";
};